module.exports = __webpack_public_path__ + "img/ufc4.e45b8a71.png";